/**
 * Design tokens for the consulting site.
 *
 * ProjectHub light theme: cool near-white surfaces, near-black ink, and the
 * signature violet accent, with quiet gray for rules and folio numerals.
 * Single source of truth for color — components import from here rather than
 * hardcoding hex values.
 */

export const colors = {
  // Primary accent (violet) + hover
  primary: "#9146FF",
  boost: "#7B31FF",

  // Secondary (quiet gray — rules, numerals, muted emphasis) + hover
  secondary: "#6b7280",
  secondaryBoost: "#4b5563",

  // Status
  error: "#ef4444",
  success: "#23ce6b",
  warning: "#f59e0b",
  info: "#4c6ef5",

  // Surfaces
  background: "#f7f7fa",
  paper: "#ffffff",
  textPrimary: "#111827",
  textSecondary: "#6b7280",
  divider: "#d1d5db",

  // Soft violet tint for the single alternating section (pricing).
  tintDeep: "#F3EEFC",

  // Icon button hover (no background ever, color change only)
  iconHover: "#B388FF",
} as const;
